import { awaitDataServiceFetcher } from '@dxb-web-ui-framework/common/domain/RestfulDataTransfer/DataService/DataServiceFetchers';
import { SuccessCallback } from '@dxb-web-ui-framework/common/domain/RestfulDataTransfer/DataService/types';
import { normalizeEmptyResponseToSuccessResponse } from '@dxb-web-ui-framework/common/domain/RestfulDataTransfer/infrastructure';
import { CommunicationAlertsResponse } from '../entities';
import { ICommunicationRepository } from '../entities/ICommunicationRepository';
import { CommunicationAlertsDataResponseDTOtoCommunicationAlertsDataAdapter } from './CommunicationAlertsDataResponseDTOtoCommunicationAlertsDataAdapter';

class CommunicationRepositoryImpl implements ICommunicationRepository {
  constructor() {
    this.GetCommunicationAlerts = this.GetCommunicationAlerts.bind(this);
    this.UpdateCommunicationByCategory = this.UpdateCommunicationByCategory.bind(this);
    this.UpdateCommunicationByTask = this.UpdateCommunicationByTask.bind(this);
  }

  GetCommunicationAlerts(customerId: string): Promise<CommunicationAlertsResponse> {
    return awaitDataServiceFetcher({
      payload: {
        method: 'GET',
        url: `/secure-web/api/private/users/communication-preferences/`,
        dataAdapter: CommunicationAlertsDataResponseDTOtoCommunicationAlertsDataAdapter,
      },
    });
  }

  UpdateCommunicationByCategory(
    headerId: string,
    categoryId: string,
    email: boolean,
    sms: boolean,
    notification: boolean,
    successCallback: SuccessCallback,
  ): Promise<{}> {
    return awaitDataServiceFetcher({
      payload: {
        method: 'PUT',
        url: `/secure-web/api/private/users/communication-preferences/groups/${headerId}/categories/${categoryId}`,
        data: {
          enableEmail: Boolean(email),
          enableSms: Boolean(sms),
          enablePush: Boolean(notification),
        },
        nextCallback: successCallback,
        dataAdapter: normalizeEmptyResponseToSuccessResponse,
      },
    });
  }

  UpdateCommunicationByTask(
    headerId: string,
    categoryId: string,
    taskId: string,
    email: boolean,
    sms: boolean,
    notification: boolean,
    successCallback: SuccessCallback,
  ): Promise<{}> {
    return awaitDataServiceFetcher({
      payload: {
        method: 'PUT',
        url: `/secure-web/api/private/users/communication-preferences/groups/${headerId}/categories/${categoryId}/tasks/${taskId}`,
        data: {
          enableEmail: Boolean(email),
          enableSms: Boolean(sms),
          enablePush: Boolean(notification),
        },
        nextCallback: successCallback,
        dataAdapter: normalizeEmptyResponseToSuccessResponse,
      },
    });
  }
}

export { CommunicationRepositoryImpl };
